<template>
  <v-flex xs12>
    <div class="body-2 grey--text text--darken-1">
      <slot></slot>
    </div>
  </v-flex>
</template>

<script>
export default {};
</script>

<style>
</style>
